import { Component, Input, OnInit } from "@angular/core";
import { ExtlogDetail } from "app/models/extlog.model";

@Component({
  selector: "app-extlog-table",
  templateUrl: "./extlog-table.component.html",
  styleUrls: ["./extlog-table.component.css"],
})
export class ExtlogTableComponent implements OnInit {
  @Input() extlogDetails: ExtlogDetail[];
  showDetailDialog = false;
  selectedLogContent: string

  constructor() {}

  ngOnInit() {}

  onOpenDetailDialog(logContent: string) {
    this.selectedLogContent = logContent;
    this.showDetailDialog = true;
  }

  onClosePopupInfo() {
    this.showDetailDialog = false;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case "0":
        return "extlog-ok";
      case "1":
        return "extlog-error";
      default:
        return "";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/extlog/extlog/extlog-table/extlog-table.component.ts